import { Typography } from '@mui/material'
import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { Offcanvas } from '@/entities/offcanvas'
import { UpdateSchoolCafeteriaForm } from '@/features/update-school-cafeteria/ui/UpdateSchoolCafeteria'
import { useSchoolCafeteriaItem } from '@/shared/api/school-cafeteria'
import { useRouteOffcanvas } from '@/shared/hooks/use-route-offcanvas'
import { OffcanvasSkeleton } from '@/shared/ui/offcanvas-skeleton'

export const Route = createFileRoute(
  '/_auth/administration/reference-books/canteens/connects/update/$connectId'
)({
  component: RouteComponent,
})

function RouteComponent() {
  const { isOpen, close } = useRouteOffcanvas('../..')
  const { t } = useTranslation()
  const { connectId } = Route.useParams()
  const { data: canteen, isLoading, isError } = useSchoolCafeteriaItem(connectId)

  return (
    <Offcanvas open={isOpen} onClose={close} title={t('Редактирование связи школа - столовая')}>
      {isLoading && <OffcanvasSkeleton />}
      {isError && (
        <Typography color="error">{t('Техническая ошибка. Повторите попытку позже')}</Typography>
      )}
      {canteen && <UpdateSchoolCafeteriaForm onClose={close} link={canteen} />}
    </Offcanvas>
  )
}
